import React from "react";
import PropTypes from "prop-types";

const MarkIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2501 18.0544L20 9.30442L18.1935 7.50008L11.2501 14.4435L7.36095 10.6935L5.55443 12.5001L11.2501 18.0544ZM12.5001 0.000109811C14.9723 0.000109811 17.389 0.733219 19.4446 2.10673C21.5003 3.48024 23.1024 5.43247 24.0485 7.71653C24.9946 10.0006 25.2421 12.5139 24.7598 14.9387C24.2775 17.3634 23.087 19.5907 21.3388 21.3388C19.5907 23.087 17.3634 24.2775 14.9387 24.7598C12.5139 25.2421 10.0006 24.9946 7.71653 24.0485C5.43247 23.1024 3.48024 21.5003 2.10673 19.4446C0.733219 17.389 0.000109811 14.9723 0.000109811 12.5001C-0.00679311 10.8566 0.311815 9.22806 0.937551 7.70838C1.56329 6.1887 2.48376 4.80797 3.64587 3.64587C4.80797 2.48376 6.1887 1.56329 7.70838 0.937551C9.22806 0.311815 10.8566 -0.00679311 12.5001 0.000109811Z"
        fill={fill}
      />
    </svg>
  );
};

MarkIcon.defaultProps = {
  width: 25,
  height: 25,
  fill: "white",
};

export default MarkIcon;
